@if(formControlItem){
  <div>
    @if(label){
      <label [for]="id" class="block text-sm font-medium leading-6 ">{{label |translate}}</label>
    }
    <div class="relative mt-2 rounded-md shadow-sm">
      <input [type]="type"
             [formControl]="formControlItem"
             [id]="id"
             [name]="id"
             autocomplete="off"
             [placeholder]="placeholder || ''"
             [ngClass]="{
                  'pl-10': iconPrefix,
                  'pl-4': !iconPrefix,
                  'pr-10': iconSufix,
                  'text-white': styling === TInputStyles.transparentSolid || styling === TInputStyles.darkBig,
                  'pr-4': !iconSufix,
                  'border-white': styling === TInputStyles.transparentSolid,
                  'border-disable text-light-text placeholder-disable ': styling === TInputStyles.defaultBorderInput,
                  'rounded-md border border-1 border-solid py-1 placeholder:text-secondary-hover text-18': styling === TInputStyles.transparentSolid || styling === TInputStyles.defaultBorderInput,
                  'rounded-lg border-0 py-1.5 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6': styling === TInputStyles.transparentBig
             }"
             class=" w-full rounded-md border  px-4 py-2 text-sm font-semibold  !outline-none  focus:ring-transparent border-[#17263c] bg-input text-normal focus:border-primary ps-10 placeholder:text-normal {{customClasses}}"  >
      <div class="cursor-pointer absolute inset-y-0 right-0 flex items-center pr-3" (click)="eyeOn()">
        <img class="h-5 w-5 text-gray-400" src="assets/icons/base/{{showPass? 'eye.svg': 'eye-off.svg'}}" alt="">
      </div>
    </div>
    @if(formControlItem.invalid && (formControlItem.dirty || formControlItem.tuched)) {
      <app-validation-error [control]='formControlItem' class="text-red-500 text-xs italic"></app-validation-error>
    }

  </div>
} @else {
  <div>
    @if(label){
      <label [for]="id" class="block text-sm font-medium leading-6">{{label | translate}}</label>
    }
    <div class="relative mt-2 rounded-md shadow-sm">
      <input #currentElement [type]="type"
             [id]="id"
             [value]="value"
             [name]="id"
             autocomplete="off"
             (input)="valueChange($event)"
             (blur)="onBlur()"
             [ngClass]="{
                  'pl-10': iconPrefix,
                  'pl-4': !iconPrefix,
                  'pr-10': iconSufix,
                  'text-white': styling === TInputStyles.transparentSolid || styling === TInputStyles.darkBig,
                  'pr-4': !iconSufix,
                  'border-white': styling === TInputStyles.transparentSolid,
                  'border-disable text-light-text placeholder-disable ': styling === TInputStyles.defaultBorderInput,
                  'rounded-md border border-1 border-solid py-1 placeholder:text-secondary-hover text-18 bg-transparent': styling === TInputStyles.transparentSolid || styling === TInputStyles.defaultBorderInput,
                  'rounded-lg border-0 py-1.5 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6': styling === TInputStyles.transparentBig
             }"
             class="h-11 block w-full hover:border-primary-hover focus:border-primary{{customClasses}}"
             [placeholder]="placeholder || ''"
      >
      <div class="cursor-pointer absolute inset-y-0 right-0 flex items-center pr-3" (click)="eyeOn()">
        <img class="h-5 w-5 text-gray-400" src="assets/icons/base/{{showPass? 'eye.svg': 'eye-off.svg'}}" alt="">
      </div>
    </div>
  </div>
}
